import React from 'react';
import { Users, Mic, MicOff, Video, VideoOff, Crown } from 'lucide-react';

const ParticipantList = ({ participants, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="w-80 bg-gray-800 border-r border-gray-700 flex flex-col flex-shrink-0">
      <div className="bg-gray-900 p-4 flex items-center justify-between border-b border-gray-700">
        <div className="flex items-center space-x-2">
          <Users size={20} className="text-white" />
          <h3 className="text-white font-semibold">
            Participants ({participants.length})
          </h3>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        {participants.length === 0 ? (
          <div className="text-center text-gray-400 text-sm mt-8">
            No participants yet
          </div>
        ) : (
          participants.map((participant) => (
            <div
              key={participant.userId || participant.id}
              className="bg-gray-700 rounded-lg p-3 flex items-center justify-between hover:bg-gray-600 transition-colors"
            >
              <div className="flex items-center space-x-3 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  {participant.isHost ? (
                    <Crown size={18} className="text-yellow-400" />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-semibold">
                      {(participant.userName || 'U')[0].toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2">
                    <p className="text-white text-sm font-medium truncate">
                      {participant.userName || 'Anonymous'}
                    </p>
                    {participant.isHost && (
                      <span className="text-xs text-yellow-400 bg-yellow-400/20 px-2 py-0.5 rounded">
                        Host
                      </span>
                    )}
                  </div>
                  <p className="text-gray-400 text-xs truncate">
                    {participant.status === 'connected' ? 'Connected' : participant.status}
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2 flex-shrink-0">
                {participant.isMuted ? (
                  <MicOff size={16} className="text-red-400" />
                ) : (
                  <Mic size={16} className="text-green-400" />
                )}
                {participant.isVideoOff ? (
                  <VideoOff size={16} className="text-red-400" />
                ) : (
                  <Video size={16} className="text-green-400" />
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ParticipantList;

